export function useTax() {
	return {
		calculateZeroTax: (price: number, taxRate: number) => {
			const taxRateAdjusted = taxRate / 100 + 1;

			return price / taxRateAdjusted;
		},
	};
}
